import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, CircularProgress } from "@mui/material";
import SoftButton from "../../components/SoftButton";

/**
 * A reusable section header with a title and an action button.
 *
 */
const SectionHeaderWithButton = ({
                                     title,
                                     buttonText,
                                     loading = false,
                                     onClick,
                                     color = "primary",
                                 }) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mt: 6,
                mb: 2,
            }}
        >
            <Typography variant="h5" fontWeight="bold">
                {title}
            </Typography>

            <SoftButton
                variant="contained"
                color={color}
                onClick={onClick}
                disabled={loading}
                sx={{
                    borderRadius: 3,
                    textTransform: "none",
                    px: 3,
                    minWidth: 130,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                }}
            >
                {loading ? (
                    <>
                        <CircularProgress size={20} color="inherit" />
                        Loading...
                    </>
                ) : (
                    buttonText
                )}
            </SoftButton>
        </Box>
    );
};

SectionHeaderWithButton.propTypes = {
    title: PropTypes.string,
    buttonText: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    color: PropTypes.string,
};

export default SectionHeaderWithButton;
